import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStyletron } from 'styletron-react';
import { StatefulPopover, PLACEMENT, TRIGGER_TYPE } from 'baseui/popover';
import {
  Badge,
  SHAPE,
  COLOR,
  PLACEMENT as BADGE_PLACEMENT,
} from 'baseui/badge';
import { Button, SHAPE as BUTTON_SHAPE, SIZE } from 'baseui/button';

import { AppContext, DispatcherAction } from 'context';
import { AuthService } from 'core/services/auth';

const UserProfile = () => {
  const {
    state: { user },
    dispatcher,
  } = useContext(AppContext);
  const [css] = useStyletron();
  const navigate = useNavigate();
  const authService = new AuthService();

  const resolveButtonText = (): string => {
    if (user?.firstName && user?.lastName) {
      return (
        user.firstName.substring(0, 1) + user.lastName.substring(0, 1)
      ).toUpperCase();
    }
    if (user?.firstName) {
      return user.firstName.substring(0, 2).toUpperCase();
    }
    return '';
  };

  const logoutClickedHandler = () => {
    authService.logout();
    dispatcher(DispatcherAction.Logout);
    navigate('/');
  };

  return (
    <>
      <StatefulPopover
        placement={PLACEMENT.leftBottom}
        triggerType={TRIGGER_TYPE.click}
        content={
          <>
            <div
              className={css({
                padding: '10px',
              })}
            >
              <div className={css({ paddingTop: '10px' })}>
                <span className={css({ color: '#00aeef', fontSize: '0.9rem' })}>
                  {user?.email}
                </span>
              </div>
              <div
                className={css({
                  paddingTop: '5px',
                  display: 'flex',
                  justifyContent: 'center',
                })}
              >
                <Badge
                  content={user?.role}
                  shape={SHAPE.pill}
                  color={COLOR.positive}
                  placement={BADGE_PLACEMENT.topEdge}
                  verticalOffset="8px"
                ></Badge>
              </div>
              <div
                className={css({
                  paddingTop: '15px',
                  display: 'flex',
                  justifyContent: 'center',
                })}
              >
                <Button
                  shape={BUTTON_SHAPE.pill}
                  size={SIZE.mini}
                  onClick={logoutClickedHandler}
                >
                  Logout
                </Button>
              </div>
            </div>
          </>
        }
        accessibilityType={'tooltip'}
      >
        <Button shape={BUTTON_SHAPE.circle} size={SIZE.compact}>
          {resolveButtonText()}
        </Button>
      </StatefulPopover>
    </>
  );
};

export default UserProfile;
